import { SOURCE_TYPES } from './enum';

const validedSources = [SOURCE_TYPES.APP, SOURCE_TYPES.EMAIL, SOURCE_TYPES.WEBSITE, SOURCE_TYPES.OTHER];

export const validateTrafficSource = (source?: string) => {
  if (!source) return SOURCE_TYPES.APP;
  if (validedSources.includes(source)) return source;
  return 'unknown';
};
